/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ScaleLinear } from '#utils/PRIVATE_chartUtils';
import { Dimension } from '#utils/UNSAFE_visTypes/common';

export function getWindowCoords(
  isRtl: boolean,
  xViewportExtent: { viewportMin: number; viewportMax: number },
  xAxisExtent: { min: number; max: number },
  yViewportExtent: { viewportMin: number; viewportMax: number },
  yAxisExtent: { min: number; max: number },
  plotAreaSpace: Dimension
) {
  const xDomain = [xAxisExtent.min, xAxisExtent.max] as [number, number];
  const xRange = (
    isRtl
      ? [plotAreaSpace.x + plotAreaSpace.width, plotAreaSpace.x]
      : [plotAreaSpace.x, plotAreaSpace.x + plotAreaSpace.width]
  ) as [number, number];
  const xScale = new ScaleLinear(xDomain, xRange);

  const yDomain = [yAxisExtent.min, yAxisExtent.max] as [number, number];
  const yRange = [plotAreaSpace.y + plotAreaSpace.height, plotAreaSpace.y] as [number, number];

  const yScale = new ScaleLinear(yDomain, yRange);

  const windowX = xScale.transform(xViewportExtent.viewportMin);
  const windowWidth = Math.abs(
    xScale.transform(xViewportExtent.viewportMax) - xScale.transform(xViewportExtent.viewportMin)
  );

  return {
    windowX: isRtl ? windowX - windowWidth : windowX,
    windowWidth: windowWidth,
    windowY: yScale.transform(yViewportExtent.viewportMax),
    windowHeight: Math.abs(
      yScale.transform(yViewportExtent.viewportMax) - yScale.transform(yViewportExtent.viewportMin)
    ),
    xScale,
    yScale
  };
}
